<template>
 <div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
         <div class="searchBox inpBox">
            <div class="item">
             <el-form-item label="任务单号:" prop="taskNo">
                <el-input  placeholder="" v-model="searchFrom.taskNo"></el-input>
             </el-form-item>
             <el-form-item label="船舶名称:" prop="shipName">
                <el-select  v-model="searchFrom.shipName"   placeholder="请选择">
                  <el-option v-for="item in CBList" :label="item.shipName" :value="item.shipName" :key="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="航次号:" prop="voyageNo">
                <el-input  placeholder="" v-model="searchFrom.voyageNo"></el-input>
              </el-form-item>
              <el-form-item label="任务状态:" prop="taskStatus">
                <el-select  v-model="searchFrom.taskStatus"   placeholder="请选择">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="已完成" value="已完成"></el-option>
                  <el-option label="未完成" value="未完成"></el-option>
                </el-select>
              </el-form-item>
            <el-form-item label="创建时间:" prop="createTime">
                <el-date-picker
                  v-model="searchFrom.createTime"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
            </div>
        </div>
       <div class="searchBtnBox">
         <el-form-item >
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"  @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
          <el-form-item   v-if="btnFlg[0]">
            <el-button type="primary"  @click="addRegion">新增</el-button>
          </el-form-item>
          <el-form-item  v-if="btnFlg[1]">
            <el-button type="primary"  @click="delFn">删除</el-button>
          </el-form-item>
          <el-form-item  v-if="btnFlg[4]">
            <el-button type="primary" @click="xiazai">下载模板</el-button>
          </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
         <el-table-column label="操作"  width="180">
            <template slot-scope="scope">
              <div>
                <el-button type="text" size="mini" v-if="btnFlg[2]"  @click="editFn(scope.row)">修改</el-button>
                <el-button type="text" size="mini" v-if="btnFlg[3]"  @click="HWMXfn(scope.row)">货物明细</el-button>
                <el-button type="text" size="mini" v-if="btnFlg[4]"  @click="daoruFn(scope.row)">导入货物</el-button>
              </div>
            </template>
        </el-table-column>
        <el-table-column prop="taskNo" min-width="220"  :formatter="emptyFn" label="任务单号"></el-table-column>
        <el-table-column property="taskStatus" label="任务状态" ></el-table-column>
        <el-table-column prop="shipName" width="160" :formatter="emptyFn" label="船舶名称"></el-table-column>
        <el-table-column prop="voyageNo" width="200" :show-overflow-tooltip="true" label="航次号"></el-table-column>
        <el-table-column prop="deliverAddressName" width="300" :formatter="emptyFn" label="起始港口"></el-table-column>
        <el-table-column prop="receivingAddressName" width="300" :formatter="emptyFn" label="目的港口"></el-table-column>
        <el-table-column prop="number"  min-width="200" :formatter="emptyFn" label="数量"></el-table-column>
        <el-table-column prop="numberOfPallets"  min-width="200" :formatter="emptyFn" label="货垛数"></el-table-column>
        <el-table-column prop="weight"  min-width="200" :formatter="emptyFn" label="重量(吨)"></el-table-column>
        <el-table-column prop="createUser" width="150" :formatter="emptyFn" label="创建人"></el-table-column>
        <el-table-column prop="createTime" width="170" :formatter="dateTimeFormat"  label="创建时间"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
       <!-- 导入 -->
    <importC   v-if="importDialog" @DRsave="DRsave" @destroy="destroy"></importC>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { getShipInkjetTaskList, delShipInkjetTask, addShipInkjetDetail, getShipIdAndNameList, sShipFlowUpdateFlow, againPublishFlow } from '@/api/shipping'
import { emptyFn, dateTimeFormat } from '@/utils/util'
import importC from '@/components/import.vue'
export default {
  components: {
    importC
  },
  data () {
    return {
      h: 500,
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      ids: [],
      loading: 'false',
      CBList: [], // 船舶
      productTypes: [],
      importDialog: false,
      btnFlg: [],
      btnIdArr: ['00KM0H0100', '00KM0H0200', '00KM0H0300', '00KM0H0400', '00KM0H0500']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr)
    getShipIdAndNameList().then(res => {
      this.CBList = res
    })
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 98) + 'px'
  },
  methods: {
    xiazai () {
      window.open(
        'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/tms/excel/%E6%A0%87%E8%AE%B0%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF-V1.0.xlsx'
      )
    },
    // 货物明细
    HWMXfn (row) {
      this.$router.push({ path: '/shippingSprayCode/goodList', query: { id: row.id } })
    },
    // 导入
    daoruFn (row) {
      this.importDialog = true
      this.id = row.id
    },
    DRsave (formData) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      formData.set('params', JSON.stringify({ id: this.id }))
      addShipInkjetDetail(formData).then(res => {
        loading.close()
        this.importDialog = false
        this.importMsg = this.$message({
          showClose: true,
          message: res,
          duration: 3000,
          type: 'success',
          onClose () {
            loading.close()
          }
        })
        this.getList(this.searchFrom)
      }).catch(error => {
        this.importMsg = this.$message({
          showClose: true,
          message: error.message,
          duration: 3000,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    destroy () {
      this.importDialog = false
    },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }
      if (this.searchFrom.createTime) {
        this.$set(this.searchFrom, 'createTimeStart', this.searchFrom.createTime[0])
        this.$set(this.searchFrom, 'createTimeEnd', this.searchFrom.createTime[1])
      } else {
        this.$set(this.searchFrom, 'createTime', null)
      }
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      getShipInkjetTaskList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 添加
    addRegion () {
      this.$router.push({ path: '/shippingSprayCode/addTast' })
    },
    editFn (row) {
      this.$router.push({ path: '/shippingSprayCode/addTast', query: { id: row.id } })
    },
    // 删除
    delFn () {
      const selectData = this.$refs.table.selection
      if (selectData.length != 1) {
        this.$alert('请选择一条要操作的数据', '系统提示')
      } else {
        this.$confirm('是否执行删除操作?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          delShipInkjetTask({ id: selectData[0].id }).then(res => {
            loading.close()
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }).catch(() => {

        })
      }
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        createTime: null
      }
    },
    closeDialog () {
      this.addFrom = { mudigang: [{ key: 1 }], pricingMethod: 1 }
      this.$refs.table.clearSelection()
      this.flag = false
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.searchBox .el-date-editor{
      width: 350px!important;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}
/deep/ .inpBox .el-date-editor .el-input__inner {
    width: 150px;
}
.jiage{
  position: relative;
  .danwei1{
    position: absolute;
    right: 6px;
  }
}
.iconBox {
  position: absolute;
  right: -28px;
  top: 0;
  font-size: 20px;
  color: #0b25d6;
  z-index: 9999;
}
/deep/.el-textarea{
      width: 442px;
}
.hwlx /deep/.el-input__inner{
  width: 440px;

}
</style>
